import type maplibregl from 'maplibre-gl'
import type { SelectableFeatureRef } from './selectable-feature-ref.js'
import type { SelectableLayerProvider } from './highlight-adapter.js'

const providers: SelectableLayerProvider[] = []

export function registerSelectableLayerProvider(provider: SelectableLayerProvider): void {
  if (!providers.includes(provider)) {
    providers.push(provider)
  }
}

export function unregisterSelectableLayerProvider(provider: SelectableLayerProvider): void {
  const idx = providers.indexOf(provider)
  if (idx >= 0) providers.splice(idx, 1)
}

export function getSelectableOverlayLayerIds(): string[] {
  return providers.flatMap(p => p.getSelectableLayerIds())
}

export function mapGeoJSONFeatureToRef(
  hit: maplibregl.MapGeoJSONFeature
): SelectableFeatureRef | null {
  for (const provider of providers) {
    const ref = provider.featureToRef(hit)
    if (ref) return ref
  }
  return null
}
